/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Calm leak chip. Never alert/danger/red-flag.
 *
 * Categories: STALLED_PERCEPTION, FOLLOWUP_DEPTH_NEEDED,
 * FAMILY_ALIGNMENT_PENDING, DECISION_CLARITY_PENDING, NEEDS_MOVEMENT.
 */
const TONE = {
  STALLED_PERCEPTION:        'bg-stone-100  text-stone-700   border-stone-300',
  FOLLOWUP_DEPTH_NEEDED:     'bg-amber-50   text-amber-800   border-amber-300',
  FAMILY_ALIGNMENT_PENDING:  'bg-violet-50  text-violet-800  border-violet-200',
  DECISION_CLARITY_PENDING:  'bg-sky-50     text-sky-800     border-sky-200',
  NEEDS_MOVEMENT:            'bg-stone-50   text-stone-600   border-stone-200',
};

const LABEL = {
  STALLED_PERCEPTION:       'Stalled perception',
  FOLLOWUP_DEPTH_NEEDED:    'Follow-up depth needed',
  FAMILY_ALIGNMENT_PENDING: 'Family alignment pending',
  DECISION_CLARITY_PENDING: 'Decision clarity pending',
  NEEDS_MOVEMENT:           'Needs movement',
};

export default function LeakChip({ code, compact = false }) {
  const tone = TONE[code] || TONE.NEEDS_MOVEMENT;
  return (
    <span
      data-testid={`leak-chip-${code}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] uppercase tracking-[0.14em] font-['Work_Sans'] ${tone}`}
    >
      <span className="w-1 h-1 rounded-full bg-current opacity-60" />
      {compact ? (LABEL[code] || code).split(' ')[0] : (LABEL[code] || code)}
    </span>
  );
}
